module.exports = __webpack_public_path__ + "img/turban-space.73614259.png";